import React from "react";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { fetchAccounts } from "../../queries/bank/accountsQuery";
import api from "../../utils/api";

class NewAccountCollection extends React.Component {
  state = {
    error: {},
    isSubmitting: false,
    accounts: [],
    status: {
      label: "Active",
      value: true,
    },
  };

  componentDidMount = async () => {
    await this.getAccounts(true);

    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  };

  getAccounts = async (isLoadingAccounts) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingAccounts });

      const accounts = await fetchAccounts(defaultLanguage, {
        listType: "dropdown",
        active: false,
      });

      this.setState({
        accounts,
        isLoadingAccounts: false,
      });
    } catch (error) {
      this.setState({ isLoadingAccounts: false });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });
  }

  validateForm() {
    let { error, account } = this.state;
    const { collectionId } = this.props;

    if (collectionId === "") {
      error.collection =
        language[this.props.defaultLanguage].collection_required;
    }

    if (!account) {
      error.account = language[this.props.defaultLanguage].account_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, status, account } = this.state;
    const { id, collectionId } = this.props;

    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("core")}/collection/till/account`,
        data: {
          accountId: account.value,
          collectionTillId: collectionId,
          active: status.value,
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "account_collection_update_success"
                : "account_collection_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "error",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "account_collection_update_error"
                : "account_collection_add_error"
            ]
          );
        });
    }
  };

  render() {
    return (
      <>
        <div className="card-body">
          <Input
            label={language[this.props.defaultLanguage].account}
            value={this.props.collectionName}
            error={this.state.error.account}
            disabled
          />
          <Select
            options={this.state.accounts}
            label={language[this.props.defaultLanguage].account}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.account}
            onChange={(e) => this.onChangeInput("account", e)}
            error={this.state.error.account}
            isLoading={this.state.isLoadingAccounts}
          />
          <Select
            options={[
              { label: "Active", value: "true" },
              { label: "Inactive", value: "false" },
            ]}
            label={language[this.props.defaultLanguage].status}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.status}
            onChange={(e) => this.onChangeInput("status", e)}
            error={this.state.error.status}
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewAccountCollection);
